import React from "react";
import Schedule from "./Schedule";
import { loginPageLogo, MPAA } from "../../assets";
import { GiClapperboard } from "react-icons/gi";

const Banner = () => {
  return (
    <section
      id="banner"
      className="w-full h-[800px] 2xl:h-[600px] xl:h-[400px]  pb-20 2xl:pb-10 flex border-b-[1px] border-b-black z-20"
    >
      <div className="px-1 py-2">
        <div className="flex py-8">
          {/* <img
            src={loginPageLogo}
            alt="loginPageLogo"
            className="flex w-[500px] h-auto mt-2 animate-pulse"
          /> */}
          <div>
            <h1 className="text-9xl 2xl:text-8xl xl:text-7xl md:text-6xl sm:text-4xl font-FreckleFace">
              Phil Page
            </h1>
            <h3 className="text-5xl 2xl:text-4xl xl:text-3xl md:text-2xl text-red-600 font-MouseMemoirs">
              c'mon login and play jokes w/ me!
            </h3>
          </div>
        </div>

        <div className="sm:pt-24 sm:opacity-0">
          <div
            className="border-4 border-white rounded-xl"
            sizes="(max-width:768) 100vw, (max-width: 1200px) 50vw, 50vw"
          >
            <div className="h-auto cursor-pointer overflow-hidden rounded-lg">
              <iframe
                width="540"
                height="295"
                src="https://www.youtube.com/embed/aEvKjYScbO0?si=dMXd9pSbUheaHwwZ&autoplay=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
                className="xl:w-[440px] xl:h-[245px] lg:h-10 sm:w-[340px] sm:h-[260px]"
              ></iframe>
            </div>
          </div>
        </div>
        <div>
          <div className="flex">
            <div>
              <img
                src={MPAA}
                alt="MPAA"
                className="flex w-[350px] 2xl:w-[300px] lg:hidden h-auto mt-4 2xl:mt2 mb-5 2xl:mb-2"
              />
            </div>
            <div>
              <GiClapperboard className="w-[160px] 2xl:w-[140px] lg:hidden h-auto" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
